import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { GIS_ROUTES } from "./gis.routes";
import { OdnrMapComponent } from "./components/odnr-map/odnr-map.component";
import { WellViewerComponent } from "./components/well-viewer/well-viewer.component";

import { GisLayerService } from "./services/gis-layer.service";
import { GisLocationService } from "./services/gis-location.service";
import { GisViewService } from "./services/gis-view.service";
import { GisTokenService } from "./services/gis-token.service";
import { GisAlertService } from "./services/gis-alert.service";
import { GisQueryService } from "./services/gis-query.service";
import { WellViewerService } from "./services/well-viewer.service";
import { SceneOverlayComponent } from './components/odnr-map/renderer/overlays/scene-overlay/scene-overlay.component';
import { ForeignWellInformationComponent } from './components/odnr-map/renderer/casing-plan-components/foreign-well-information/foreign-well-information.component';
import { CasingPlanInformationComponent } from './components/odnr-map/renderer/casing-plan-components/casing-plan-information/casing-plan-information.component';
import { IntersectionErrorComponent } from './components/odnr-map/renderer/casing-plan-components/intersection-error/intersection-error.component';

@NgModule({ declarations: [
        OdnrMapComponent,
        WellViewerComponent,
        SceneOverlayComponent,
        ForeignWellInformationComponent,
        CasingPlanInformationComponent,
        IntersectionErrorComponent
    ],
    exports: [
        OdnrMapComponent,
        ForeignWellInformationComponent,
        CasingPlanInformationComponent,
        CasingPlanInformationComponent,
        WellViewerComponent,
        SceneOverlayComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(GIS_ROUTES)], providers: [
        GisLayerService,
        GisLocationService,
        GisViewService,
        GisTokenService,
        GisAlertService,
        GisQueryService,
        WellViewerService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class GisModule { }
